import React from 'react';
import logo from './logo.svg';
import './App.css';
import Navigation from './navigations';

function App() {
  return (
    <div className="App">
     <Navigation/>
    </div>
  );
}

export default App;
